export default{
    peomessage:{
        btnState:{
            btn1:'Save',
            btn2:'Saved successfully'
        },
        fromtitle:{
            from1:'Profile Picture',
            from2:'Nickname',
            from3:'Full Name',
            from4:'Gender',
            from5:'Contact Number',
            from6:'Business Email',
            from7:'Region',
            from8:'Detailed Address',
            from9:'Male',
            from10:'Female',
        },
        placeholderlist:{
            pla1:'Enter nickname',
            pla2:'Enter full name',
            pla3:'Enter contact number',
            pla4:'Enter business email',
            pla5:'Enter detailed address',
            pla6:'Select region',
        },
        rulesMessage:{
            rule1:'Enter valid email format',
            rule2:'Enter nickname',
            rule3:'Enter full name',
            rule4:'Select gender',
            rule5:'Enter phone number',
            rule6:'Enter valid phone number',
            rule7:'Enter email',
            rule8:'Select region',
            rule9:'Enter detailed address',
            rule10:'Upload valid image format',
            rule11:'Image size cannot exceed 10MB',
            rule12:'For better support, upload images (max 10MB, JPG/PNG/JPEG formats)'
        }
    }
}